import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import CircularProgressbar from 'react-circular-progressbar';
import { debounce, get, map } from 'lodash';
import axios from 'axios';
import 'react-circular-progressbar/dist/styles.css';
import HomeCard from '../../containers/HomeCard';
import Loading from '../../components/Loading';
import { API_HOST } from '../../consts';
import Ruler from '../../components/Ruler';
import AddButton from '../../components/buttons/AddButton';

import { ItemTotal, ItemTotalCalibrado } from './styles';
import queryString from 'query-string';
import ReactPaginate from 'react-paginate';

const LIMITE_AREAS_CONHECIMENTO = 10;

export default class HomePage extends Component {
  state = {
    itens: [],
    mostrarTodasAreasConhecimento: false,
    fetchingItens: true,
    encomendas: [],
    fetchingData: true,
    page: 1,
    page_size: 10
  };

  componentDidMount() {
    this.fetchItens();
    this.fetchEncomendas();
  }
  fetchDataCallback() {}
  getParams = () => {
    const { page, page_size, ordering } = this.state;
    return {
      page,
      page_size,
      search: this.search,
      ordering,
      ...this.params
    };
  };

  fetchItens() {
    axios.get(`${API_HOST}/dashboards/itens`).then((response) => {
      this.setState({ itens: response.data, fetchingItens: false });
    });
  }

  fetchEncomendas() {
    this.setState({ fetchingData: true });
    const api = `${API_HOST}/encomenda/encomenda/summary_encomenda`;
    axios.get(api, { params: this.getParams() }).then((response) => {
      this.setState(
        {
          encomendas: response.data.results,
          total: get(response, 'data.count', '-'),
          total_pages: get(response, 'data.total_pages', 0),
          fetchingData: false
        },
        () => {
          this.fetchDataCallback(response.data.results);
        }
      );
    });
  }

  debouncedFetchData = debounce((search, loading = true) => {
    this.search = search;
    this.setState({ page: 1 }, () => this.fetchEncomendas(loading));
  }, 500);

  changePage = (pagination) => {
    const { location, history } = this.props;
    this.setState({ fetchingData: true });
    const page = pagination.selected + 1;
    this.setState({ page }, this.fetchEncomendas);
    const search = queryString.stringify({
      ...queryString.parse(location.search),
      page
    });
    history.push(`${location.pathname}?${search}`);
  };

  mostrarAreasConhecimento = () => {
    const { mostrarTodasAreasConhecimento } = this.state;
    this.setState({
      mostrarTodasAreasConhecimento: !mostrarTodasAreasConhecimento
    });
  };

  renderItens() {
    const { itens, mostrarTodasAreasConhecimento, fetchingItens } = this.state;
    const exames = get(itens, 'exames');
    const total = get(itens, 'total');
    const calibrados = get(itens, 'calibrados');
    let areas_conhecimento = get(itens, 'areas_conhecimento') || [];

    if (!mostrarTodasAreasConhecimento) {
      areas_conhecimento = areas_conhecimento.slice(
        0,
        LIMITE_AREAS_CONHECIMENTO
      );
    }

    return (
      <HomeCard
        icon=""
        title="Itens"
        ref={(node) => {
          this.itensCard = node;
        }}
      >
        {fetchingItens ? (
          <Loading />
        ) : (
          <Fragment>
            <div className="row">
              <div className="col-sm-6">
                <div className="animated fadeIn">
                  <ItemTotal>
                    <label>Total</label>
                    <h3>{total}</h3>
                  </ItemTotal>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="animated fadeIn">
                  <ItemTotalCalibrado>
                    <label style={{ color: 'white' }}>Calibrados</label>
                    <Ruler />
                    <h3>{calibrados}</h3>
                  </ItemTotalCalibrado>
                </div>
              </div>
            </div>
            <h3 className="mt-3 mb-12">Áreas de conhecimento</h3>
            <div className="row">
              <div className="col-sm-6 areas-conhecimento">
                {map(areas_conhecimento, (a) => (
                  <div key={a.descricao}>
                    <div>
                      <p>
                        {a.descricao}{' '}
                        <span className="pull-right">
                          <b>{a.itens} itens</b>
                        </span>
                      </p>
                    </div>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        aria-valuenow={a.porcentagem * 100}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{ width: `${a.porcentagem * 100}%` }}
                      />
                    </div>
                  </div>
                ))}

                <AddButton
                  type="button"
                  onClick={this.mostrarAreasConhecimento}
                  className="btn primary-button mt-3"
                  icon={
                    mostrarTodasAreasConhecimento
                      ? 'chevron-up'
                      : 'chevron-down'
                  }
                  title={
                    mostrarTodasAreasConhecimento
                      ? 'Mostrar menos'
                      : 'Mostrar mais'
                  }
                />
              </div>
            </div>
            <hr />
            <h3 className="mb-3">Exames</h3>
            <div className="row">
              {map(exames, (e) => (
                <div key={e.porcentagem} className="col-sm-3">
                  <div className="circle-chart-total">
                    <CircularProgressbar
                      percentage={e.porcentagem * 100}
                      initialAnimation
                      styles={{
                        path: { stroke: '#45C0F5' }
                      }}
                      textForPercentage={() => e.itens}
                    />
                    <p className="text-center">{e.descricao}</p>
                  </div>
                </div>
              ))}
            </div>
          </Fragment>
        )}
      </HomeCard>
    );
  }

  render() {
    const { encomendas, total, total_pages, page } = this.state;

    return (
      <div className="container dashboard-main">
        <div className="row">
          <div className="col-sm-12">{this.renderItens()}</div>

          <div className="col-sm-12">
            <HomeCard icon="newspaper-o" title="Encomendas">
              <table className="table">
                <thead>
                  <tr>
                    <th>Título</th>
                    <th>Entregues/Solicitados</th>
                    <th>Data limite</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {encomendas.map((d) => (
                    <tr key={d.id}>
                      <td>
                        <Link to={`/encomendas?search=${d.id}`}>{d.nome}</Link>
                      </td>
                      <td>{d.quantidade}</td>
                      <td>{d.termino_recebimento_item || '-'}</td>
                      <td>{get(d, 'status.descricao') || '-'}</td>
                    </tr>
                  ))}
                  <div
                    style={{
                      display: 'flex',
                      width: 'auto',
                      justifyContent: 'center',
                      marginTop: 15,
                      marginBottom: 5
                    }}
                  >
                    <div className="col-md-6">
                      <ReactPaginate
                        pageCount={total_pages}
                        pageRangeDisplayed={2}
                        marginPagesDisplayed={1}
                        previousLabel="ANTERIOR"
                        nextLabel="PRÓXIMA"
                        onPageChange={this.changePage}
                        initialSelected={page}
                        forcePage={page - 1}
                        containerClassName="pagination"
                        activeClassName="active"
                        disabledClassName="disabled"
                        disableInitialCallback
                        breakLabel={<button className="disabled">...</button>}
                      />
                    </div>
                  </div>
                </tbody>
              </table>
            </HomeCard>
          </div>
          <div className="col-sm-6">
            <HomeCard icon="newspaper-o" title="Editais">
              <p>Nenhum edital.</p>
            </HomeCard>
          </div>
          <div className="col-sm-6">
            <HomeCard icon="file-text-o" title="Testes">
              <p>Nenhum teste.</p>
            </HomeCard>
          </div>
        </div>
      </div>
    );
  }
}
